import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  // Base styles
  [
    'inline-flex',
    'items-center',
    'justify-center',
    'gap-2',
    'rounded-lg',
    'font-medium',
    'transition-all',
    'duration-200',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-offset-2',
    'dark:focus:ring-offset-slate-900',
    'disabled:opacity-50',
    'disabled:cursor-not-allowed',
    'disabled:pointer-events-none',
  ],
  {
    variants: {
      variant: {
        primary: [
          'bg-primary-600',
          'text-white',
          'hover:bg-primary-700',
          'active:bg-primary-800',
          'focus:ring-primary-500',
        ],
        secondary: [
          'bg-secondary-100',
          'dark:bg-secondary-900',
          'text-secondary-900',
          'dark:text-secondary-100',
          'hover:bg-secondary-200',
          'dark:hover:bg-secondary-800',
          'active:bg-secondary-300',
          'dark:active:bg-secondary-700',
          'focus:ring-secondary-500',
        ],
        outline: [
          'border-2',
          'border-gray-300',
          'dark:border-slate-600',
          'bg-transparent',
          'text-gray-700',
          'dark:text-slate-300',
          'hover:bg-gray-50',
          'dark:hover:bg-slate-800',
          'active:bg-gray-100',
          'dark:active:bg-slate-700',
          'focus:ring-gray-500',
        ],
        ghost: [
          'bg-transparent',
          'text-gray-700',
          'dark:text-slate-300',
          'hover:bg-gray-100',
          'dark:hover:bg-slate-700',
          'active:bg-gray-200',
          'dark:active:bg-slate-600',
          'focus:ring-gray-500',
        ],
        danger: [
          'bg-red-600',
          'text-white',
          'hover:bg-red-700',
          'active:bg-red-800',
          'focus:ring-red-500',
        ],
        success: [
          'bg-green-600',
          'text-white',
          'hover:bg-green-700',
          'active:bg-green-800',
          'focus:ring-green-500',
        ],
      },
      size: {
        sm: ['text-sm', 'px-3', 'py-1.5', 'min-h-[32px]'],
        md: ['text-base', 'px-4', 'py-2', 'min-h-[40px]'],
        lg: ['text-lg', 'px-6', 'py-3', 'min-h-[48px]'],
        xl: ['text-xl', 'px-8', 'py-4', 'min-h-[56px]'],
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);
